/**
 * Atestado/relatório a partir de DocumentReference (category=atestado).
 * O texto do relatório não fica estruturado no FHIR (só o PDF em Binary).
 * note pode vir vazio — profissional precisa reescrever se for reemitir.
 */
export function mapCertificateDocumentToIntervention(documentReference: any) {
  const typeDisplay =
    documentReference?.type?.coding?.[0]?.display || "Relatório";
  const description = documentReference?.description || "";

  return {
    tabValue: "3",
    type: "certificate",
    name: typeDisplay,
    tag: "AT",
    form: "",
    note: description,
    fromEditHydration: true,
    documentReferenceId: documentReference?.id,
  };
}

/**
 * Protocolos aplicados na extension do QuestionnaireResponse do encounter.
 * Formato escrito em BuildQuestionnaireResponse (valueReference lista ou item).
 */
export function extractAppliedProtocolsFromQuestionnaireResponse(
  questionnaireResponse: any
): Array<{ display: string; reference: string }> {
  const extensions = questionnaireResponse?.extension;
  if (!Array.isArray(extensions)) return [];

  const protocolExts = extensions.filter(
    (ext: any) =>
      ext?.url ===
      "https://fluxmed.com.br/fhir/StructureDefinition/appliedprotocol"
  );

  const results: Array<{ display: string; reference: string }> = [];

  protocolExts.forEach((ext: any) => {
    const valueRef = ext?.valueReference;
    const refs = Array.isArray(valueRef) ? valueRef : valueRef ? [valueRef] : [];

    refs.forEach((ref: any) => {
      const reference =
        ref?.reference?.replace("QuestionnaireResponse/", "") ||
        ref?.reference ||
        "";
      const display = ref?.display || reference || "Protocolo";
      if (reference || display) {
        results.push({ display, reference });
      }
    });
  });

  return results;
}
